import { apiRequest } from "./client";
import { normalizeConversation } from "./conversation-lifecycle-wire";
import type { DurableConversation } from "./conversations";

export interface InputTargetConversation extends DurableConversation {
  target_kind: "chat" | "subagent";
  native_subagent: {
    status: string;
    model: string | null;
    context_used_tokens: number | null;
    context_window_max: number | null;
  } | null;
  /** The latest message's prediction when that message is the assistant's. */
  pending_next_prompt: string | null;
}

/** Recent active Denker chats and native sub-agents, current project first;
 *  with `search`, only those whose name or ticket matches. */
export async function listInputTargetConversations({
  currentProjectId,
  limit,
  search,
}: {
  currentProjectId?: string;
  limit: number;
  search?: string;
}): Promise<InputTargetConversation[]> {
  const params = new URLSearchParams({
    target_picker: "true",
    limit: String(limit),
  });
  if (currentProjectId) params.set("current_project_id", currentProjectId);
  if (search) params.set("search", search);
  const response = await apiRequest<{
    status: "success";
    data: InputTargetConversation[];
  }>(`/api/v1/conversations/?${params.toString()}`, {
    method: "GET",
    silent: true,
  });
  return response.data.map((row) => ({
    ...row,
    lifecycle: normalizeConversation(row).lifecycle,
  }));
}
